export const coolIconKeys: string[] = [
    "Rows4", "Video",
    "Plane", "LayoutDashboard", "LayoutGrid", "Square", "Snowflake",
    "CircleDashed", "AlignCenterHorizontal", "Disc", "Infinity",
    "Maximize", "Play", "Sparkles", "Music",
    "Wallet", "Layout", "Zap", "Circle", "Coffee",
    "ImageOff", "Sun", "Cable", "CalendarDays",
    "Dices", "Shapes", "Cloud", "Palette",
    "CreditCard", "Headphones", "Egg", "Disc3", "Flag",
    "Bandage", "Thermometer", "Hexagon", "Network", "Library", "Pizza",
    "Cpu", "Plug", "Files", "Globe", "SignalZero",
    "Gamepad2", "CloudLightning", "ListTree", "Command"];
